<template>
  <div class="desktop">
    <!-- Icons -->
    <div :class="{ desktopIcons: !isMobile, desktopIconsMobile: isMobile }">
      <DesktopIcon
        v-for="(program, i) in programList"
        :key="`${program}-${i}`"
        :title="program"
        @clicked="showModal(program)"
        @easterEgg="startEasterEgg($event)"
      />
    </div>

    <div v-if="!isMobile" class="desktopIconBin">
      <DesktopIcon title="RecycleBin" />
    </div>

    <!-- Modal -->
    <transition name="modalAnim" mode="in-out">
      <Modal
        v-if="clicked"
        :windowName="currentWindowName"
        :isMobile="isMobile"
        :english="english"
        :easterEggData="easterEggData"
        @english="english = $event"
        @closed="
          clicked = !clicked;
          currentWindowName = '';
        "
      />
    </transition>

    <!-- Welcome Modal -->
    <transition name="modalAnim" mode="in-out">
      <Modal
        v-if="welcome"
        :windowName="'Welcome'"
        :english="english"
        @english="english = $event"
        @closed="welcome = !welcome"
      />
    </transition>

    <!-- Taskbar -->
    <Taskbar
      :programList="programList"
      :currentProgram="currentWindowName"
      @clicked="showModal($event)"
    />
  </div>
</template>

<script>
import DesktopIcon from "./DesktopIcon.vue";
import Modal from "./Modal.vue";
import Taskbar from "./Taskbar.vue";

export default {
  name: "Desktop",
  components: {
    DesktopIcon,
    Modal,
    Taskbar,
  },
  data: function () {
    return {
      clicked: false,
      welcome: false,
      isMobile: false,
      english: true,
      currentWindowName: "",
      easterEggData: {},
      document: document.documentElement,
      programList: [
        "WhoAmI",
        "Capsule",
        "MapFromGeoIP",
        "Artfolio",
        "WiiMenu",
        "Lyruna",
        "FramedBot",
        "CleanMob",
        "Funny404",
      ],
    };
  },
  mounted: function () {
    setTimeout(() => {
      this.welcome = true;
    }, 700);
    var check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cmd|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    this.isMobile = check;
  },
  methods: {
    showModal(currWinName) {
      this.welcome = false;
      this.clicked = true;
      this.currentWindowName = currWinName;
    },
    startEasterEgg(event) {
      this.easterEggData = event;
      if (this.easterEggData.step == 2) {
        setTimeout(() => {
          this.clicked = false;
          this.currentWindowName = "";
          this.document.style.setProperty("--display-body", "0");
          this.document.style.setProperty("--display-sorry", "flex");
        }, 3000);
      }
      this.showModal("EasterEgg");
    },
  },
};
</script>

<style>
.desktopIcons {
  display: flex;
  align-items: center;
  position: absolute;
  flex-flow: column wrap;
  margin: 30px 0 0 30px;
  min-height: 456px;
  height: 55%;
}
.desktopIconBin {
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 60px;
  right: 20px;
  margin: 30px 0 0 30px;
}
.desktopIconsMobile {
  display: flex;
  position: absolute;
  align-items: center;
  flex-flow: row wrap;
  width: calc(100vw - 3rem);
  margin: auto;
}
.modalAnim-enter-active {
  animation: appear forwards 0.2s;
}
.modalAnim-leave-active {
  animation: disappear forwards 0.1s;
}

@keyframes appear {
  0% {
    z-index: 1;
    opacity: 0;
    transform: scale(0.92);
  }
  100% {
    z-index: 1;
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes disappear {
  100% {
    transform: scale(0.92);
    opacity: 0;
  }
}
</style>
